export type SearchFamilyGoup = {
  FamilyGroup: string
  ProductType: string
}

export const initialValueOfSearchFamilyGoup:SearchFamilyGoup = {
  FamilyGroup: "",
  ProductType:""
}